<div class="rich-presence-state">
  @if (loading) {
    <span class="rich-presence-state__loading-indicator">
      <i class="far fa-circle-notch fa-spin"></i>
    </span>
  }

  <portal-errors [errors]="initializationError" variant="plain">
    <ng-template portalTransclude="title">
      <span class="text-danger">{{ 'richPresence.stateUnavailable' | portalTranslate }}</span>
    </ng-template>
  </portal-errors>

  @if ((loading === false || state != null) && initializationError == null) {
    <portal-dropdown-menu
      #dropdown
      [disabled]="loading"
      [ngClass]="{
        'rich-presence-state--disabled': loading,
      }"
      [placement]="dropdownPlacement"
      (hidden)="updateAfterDropdownClosed()"
      appendTo="parent"
      dropdownClass="rich-presence-state__dropdown"
    >
      <button
        class="rich-presence-state__toggle"
        *portalTransclude="'toggle'"
        [class]="'rich-presence-state--' + style?.color"
        type="button"
      >
        <div
          class="rich-presence-state__description"
          #errorTippy="tippy"
          [placement]="dropdownPlacement"
          [popover]="true"
          [portalTippy]="errorTemplate"
          appendTo="body"
          theme="danger"
          trigger="manual"
        >
          <span class="rich-presence-state__state-indicator">
            <ng-template [ngTemplateOutlet]="stateIcon" [ngTemplateOutletContext]="{ style }"></ng-template>
            <span [ngClass]="{ 'ms-1': style?.icon != null }">
              <ng-container
                [ngTemplateOutlet]="stateName"
                [ngTemplateOutletContext]="{
                  activity: state.enhancedActivity || state.activity,
                  label: state.label,
                }"
              ></ng-container>
            </span>
            <i class="far fa-angle-down ms-1"></i>
          </span>
          @if (state.note) {
            <span
              class="rich-presence-state__note"
              [portalTippy]="state.note"
              [showIfTruncated]="true"
              [tippyDisabled]="dropdown.tippy?.isVisible || false"
              placement="bottom"
              >{{ state.note }}</span
            >
          }
        </div>
      </button>
      <!-- Use [value] and (input) instead of [(ngModel)] as it throws an ExpressionHasChanged... error when pressing enter (only the first time) -->
      <input
        class="form-control rich-presence-state__note-input"
        #noteInput
        [placeholder]="'richPresence.note.placeholder' | translate"
        [value]="note"
        (input)="onNoteInput(noteInput.value)"
        (keyup.enter)="updateNote()"
        maxlength="64"
        type="text"
      />
      @for (state of availableStates; track state) {
        <button
          [class]="'rich-presence-state--' + styles[state.refActivity || state.activity].color"
          (click)="updateState(state)"
          ngbDropdownItem
        >
          <ng-template
            [ngTemplateOutlet]="stateIcon"
            [ngTemplateOutletContext]="{ style: styles[state.refActivity || state.activity] }"
          ></ng-template>
          <ng-template
            [ngTemplateOutlet]="stateName"
            [ngTemplateOutletContext]="{ activity: state.activity, label: state.label }"
          ></ng-template>
        </button>
      }
      @if (canEnableProfiles === true) {
        <div class="dropdown-divider"></div>
        <button
          class="rich-presence-state__enable-profiles"
          [disabled]="enablingProfiles"
          (click.stopImmediate)="enableProfiles()"
          ngbDropdownItem
        >
          @if (enablingProfiles) {
            <i class="far fa-circle-notch fa-spin me-1"></i>
          }
          <span>{{ 'richPresence.profiles.enable' | translate }}</span>
        </button>
      }
    </portal-dropdown-menu>
  }

  <ng-template #errorTemplate>
    <div>
      <strong>{{ error?.title | translate }}</strong>
      <div>{{ error?.message | translate }}</div>
    </div>
  </ng-template>

  <ng-template #stateIcon let-style="style">
    @if (style != null) {
      <i
        class="rich-presence-state__icon"
        [ngClass]="[style.icon, 'rich-presence-state__icon--' + style.color]"
      ></i>
    }
  </ng-template>

  <ng-template #stateName let-activity="activity" let-label="label">
    <span>{{ label || ('richPresence.state.' + activity | portalTranslate) }}</span>
  </ng-template>
</div>
